//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { useTheme } from '@mui/material/styles';
import {
  Box,
} from '@mui/material';

// === API ===
import { overruleFileException } from 'api/prokey/prokey.websocket';

// === COMPONENTS ===
import {Exception} from './components/Exception/Exception';

//#endregion

//-----------------------------------------------------------------
export function DataPanel( { data } ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const ref = useRef();

  const theme    = useTheme   ();
  const navigate = useNavigate();

  const correction_mode = useSelector( state => state.correction_mode );
  const is_correct_all = correction_mode === 'CORRECT-ALL';

  const [ is_open , setIsOpen ] = useState( false );

  //#endregion

  //#region [STYLES]

  const _styles = {
    field_paper: {
      gridColumn: 'span 4',
      overflow : 'auto'     ,
      position : 'relative' ,
      height   : '100%',
      width    : '100%',
      boxShadow: 0,
    },
    document_container: {
      height: '100%', width: '100%', overflow: 'auto',
      backgroundColor: theme.palette.background.primary[theme.palette.mode],

      scrollbarWidth: "none", // Hide the scrollbar for firefox
      '&::-webkit-scrollbar': {
          display: 'none', // Hide the scrollbar for WebKit browsers (Chrome, Safari, Edge, etc.)
      },
      '&-ms-overflow-style:': {
          display: 'none', // Hide the scrollbar for IE
      },
    },
    card: {
      variant: 'primary',
      backgroundColor: theme.palette.background.primary[theme.palette.mode],
    },
    header: {
      borderBottom: '0.5rem solid ' + (theme.palette.background.secondary[theme.palette.mode]),
      backgroundColor: theme.palette.background.primary[theme.palette.mode],
    },
    footer: {
      display: 'flex',
      height: '4rem',
      alignItems: 'center',
      textAlign: 'center',
      paddingLeft: '1rem',
      borderTop: '0.5rem solid ' + (theme.palette.background.secondary[theme.palette.mode]),
      backgroundColor: theme.palette.background.primary[theme.palette.mode],
    },
    overrule: {
      float: 'right',
    },
    comment: {
      float: 'right',
    },
  }

  const
    CONTAINER = {
      ref: ref,
      sx : _styles.field_paper,
    },
    CARD = {
      variant: 'primary',
      sx: {
        backgroundColor: theme.palette.background.primary[theme.palette.mode]
      }
    },
    HEADER = {
      sx: _styles.header,
      title: data.description,
    },
    FOOTER = {
      sx: _styles.footer,
      variant: 'primary',
    },
    BUTTON_OVERRULE = {
      sx       : _styles.overrule,
      key      : 'OVERRULE',
      variant  : 'contained',
      color    : 'primary',
      onClick  : handleOverrule,
      children : ['OVERRULE'],
    },
    COMMENT = {
      sx       : _styles.comment,
      onClick: () => { setIsOpen(true) },
    };

  //#endregion

  //#region [EFFECT]
  
  

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function onModalClose(event) {
    //-----------------------------------------------------------------
    try {
      setIsOpen(false)
    } catch (error) {
      console.warn(error);
    }
  }

  //-----------------------------------------------------------------
  function handleOverrule() {
    //-----------------------------------------------------------------
    try {
      overruleFileException( data.file_id, data.rule_id );
      navigate( -1 );
    } catch (error) {
      console.warn(error);
    }
  }

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    const rules = data.rules?.order.map( rule_id => {
      const rule = data.rules.items[rule_id];
      return <Exception data={rule}/>
    });

    return (
      <Box { ...CONTAINER }>
        {rules}
      </Box>
    );
  }

  //#endregion

  return display();
}